// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"0bfceb35","3":"dbf18469"}[chunkId] + ".chunk.js";
};